/**
 * Viewport layout helpers — size workspace panels to fit below app chrome.
 */

const APP_HEADER_H = 64;
const BATCH_SUBNAV_H = 48;
const PIPELINE_TOOLBAR_H = 48;
const MIN_CANVAS_SLICE = 96;
const INSPECTOR_FLOOR = 160;

/** Vertical space for the workspace grid (canvas + chat + inspector). */
export function getWorkspaceBodyHeight(): number {
  if (typeof window === 'undefined') return 600;
  return Math.max(
    240,
    window.innerHeight - APP_HEADER_H - BATCH_SUBNAV_H - PIPELINE_TOOLBAR_H,
  );
}

/** Maximum inspector height that still leaves room for the canvas row. */
export function getMaxInspectorHeight(): number {
  const body = getWorkspaceBodyHeight();
  return Math.max(INSPECTOR_FLOOR, body - MIN_CANVAS_SLICE);
}

/** Default inspector height on first open. */
export function getDefaultInspectorHeight(): number {
  const max = getMaxInspectorHeight();
  return Math.min(280, Math.round(max * 0.42));
}

/** Clamp any inspector height to the current viewport. */
export function clampInspectorHeight(height: number): number {
  const max = getMaxInspectorHeight();
  return Math.min(max, Math.max(INSPECTOR_FLOOR, Math.round(height)));
}

/** Target height when the Data tab is opened — capped to available viewport. */
export function getDataTabInspectorHeight(): number {
  return clampInspectorHeight(Math.round(getWorkspaceBodyHeight() * 0.5));
}

/** Target height for creation-mode inspector. */
export function getCreationModeInspectorHeight(): number {
  const max = getMaxInspectorHeight();
  return clampInspectorHeight(Math.min(400, Math.round(max * 0.62)));
}
